/*
 * @Author: liujunhong
 * @Date: 2023/7/5
 * @Desc: 
 */

//  短信验证码
export const REGEX_SMS_CODE = /^\w{4,6}$/;

//  手机号
export const REGEX_PHONE = /^[1|2](\d{10})$/;

export const REGEX_NUM = /^\d/;
